import type { AppConfig } from '@/types';

export const appConfig: AppConfig = {
  // Application basic information
  app: {
    name: 'ZappingAI',
    version: '0.1.0',
    description: 'AI Automation for Your Entire Business',
    url: process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3001',
    domain: 'zappingai.com',
  },

  // SEO and metadata
  metadata: {
    title: {
      default: 'ZappingAI - AI Automation for Your Entire Business',
      template: '%s | ZappingAI',
    },
    description:
      'ZappingAI builds intelligent systems that talk, think, and work for your business — 24/7. Automate customer service, lead generation, and content creation with our AI tools.',
    keywords: [
      'AI Automation',
      'Business Automation',
      'Customer Support AI',
      'Data Entry Automation',
      'ZappingAI',
    ],
    authors: [{ name: 'ZappingAI Team' }],
    creator: 'ZappingAI Team',
    robots: {
      index: true,
      follow: true,
    },
    openGraph: {
      type: 'website',
      locale: 'en_US',
      url: process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3001',
      siteName: 'ZappingAI',
    },
    twitter: {
      card: 'summary_large_image',
      creator: '@zappingai',
    },
  },

  // Administrator configuration
  admin: {
    emails:
      process.env.ADMIN_EMAILS?.split(',')
        .map((email) => email.trim())
        .filter(Boolean) || [],
  },

  // File upload configuration
  upload: {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/webp'], // Supported image formats: JPEG, PNG, WebP
    maxFiles: 500,
  },

  // Pagination configuration
  pagination: {
    defaultPageSize: 10,
    maxPageSize: 100,
  },
};
